<template>
  <div
    :class="{
      'sub-title-center': select === true,
      'sub-title-left': select === false
    }"
  >
    <span class="title">{{ text }}</span>
    <span class="title-line" />
  </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  name: 'sub-title',
  components: {
  },
  props: {
    text: {
      type: String,
      default: '开发数据'
    },
    select: VueTypes.bool.def(true)
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.sub-title-center {
  display: flex; flex-direction: column; align-items: center; justify-content: center;

  @include mobile {
    align-items: flex-start;
  }
}

.sub-title-left {
  display: flex; flex-direction: column;
  width: 370px;
}

.title {
  margin-bottom: 10px;
  color: #17213a;
  font-size: 34px; font-family: Alibaba-PuHuiTi-Heavy;
  line-height: 1.35;

  @include mobile {
    margin-bottom: 4px;
    color: #17213a;
    font-size: 24px; font-family: Alibaba-PuHuiTi-Heavy;
    line-height: 1.35;
  }
}

.title-line {
  width: 72px; height: 4px;
  margin-bottom: 40px;
  border-radius: 99px;
  background: linear-gradient(90deg, #315fd8 0 58%, #dc3e73 58% 100%);

  @include mobile {
    width: 48px; height: 3px;
    margin-bottom: 16px;
    background: linear-gradient(90deg, #315fd8 0 58%, #dc3e73 58% 100%);
  }
}
</style>
